
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {
  }
  ngOnInit() { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.checkUserLogin()) {
      return true;
    } else {
      // Navigate to the login page or any other page as needed
      this.router.navigateByUrl(`/`);
      return false;
    }
  }

  private checkUserLogin(): boolean {
    return localStorage.getItem('marieTokenAdmin') ? true : false;
  }
}
